<template>
    <div class="message-images-display">
        <div>
            <i class="fas fa-exclamation-circle"></i>
            <span>
                {{Language.say('messages.open.image_display.info')}}
            </span>
            <span
              @click="onLoadRemoteImages()"
              class="main-action button"
              role="button"
            >
                {{Language.say('messages.open.image_display.image_show')}}
            </span>
            <!-- <span role="button">
                {{Language.say('messages.open.image_display.image_always_show')}}
            </span> -->
        </div>
    </div>
</template>

<script setup>
  import {defineEmits} from 'vue';
  import Language      from '@/js/Shared/Language/Language.js';

  const emit = defineEmits([
    'loadRemoteImages',
  ]);

  const onLoadRemoteImages = () => {
    emit('loadRemoteImages');
  }
</script>